module.exports = __webpack_public_path__ + "img/right-arm_active.c7b0fc6e.png";